import './Section.css';

export const Section = (props) => {
    return (
        <div className="Section-container">
            {props.children}
        </div>
    );
};
